import { Chip, type ChipProps } from '@jotpsych/ui';
import type { SxProps, Theme } from '@mui/material/styles';

import { PILL_TONES, type PillTone } from './tokens';

type SxItem = Exclude<SxProps<Theme>, ReadonlyArray<unknown>>;

export interface IntakePillProps extends Omit<ChipProps, 'color' | 'variant' | 'size' | 'sx'> {
  tone?: PillTone;
  /** Uppercase the label, as the design does for state headers ("IN REVIEW"). */
  uppercase?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * The design's status pill on top of the design-system Chip (soft, xSmall).
 * Tones: indigo = ours/in progress, amber = needs the customer, green = done/live,
 * slate = locked/not started/with a third party, red = error.
 */
export function IntakePill({ tone = 'slate', uppercase = false, sx, ...props }: IntakePillProps) {
  const t = PILL_TONES[tone];
  const base: SxItem = {
    height: 22,
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.03em',
    textTransform: uppercase ? 'uppercase' : 'none',
    color: t.fg,
    backgroundColor: t.bg,
    border: `1px solid ${t.bd}`,
    '& .MuiChip-label': { paddingLeft: '8px', paddingRight: '8px' },
  };
  const extra: ReadonlyArray<SxItem> = sx === undefined ? [] : Array.isArray(sx) ? (sx as ReadonlyArray<SxItem>) : [sx as SxItem];
  return <Chip variant="soft" size="xSmall" {...props} sx={[base, ...extra]} />;
}
